import { render, staticRenderFns } from "./AppEngWrittenAssessmentLoader.vue?vue&type=template&id=bbb1da74&scoped=true"
import script from "./AppEngWrittenAssessmentLoader.vue?vue&type=script&lang=ts"
export * from "./AppEngWrittenAssessmentLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb1da74",
  null
  
)

export default component.exports